/**
 * Nalini Australia &mdash; Theme JavaScript
 */

'use strict';

// --- Mobile Nav -------------------------------------------------------------- //
(function initMobileNav() {
  const toggle   = document.getElementById('mobile-menu-toggle');
  const drawer   = document.getElementById('mobile-nav-drawer');
  const overlay  = document.getElementById('mobile-nav-overlay');
  const closeBtn = document.getElementById('mobile-nav-close');
  if (!toggle || !drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    toggle.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
})();

// --- Sticky Header Shadow ---------------------------------------------------- //
(function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const observer = new IntersectionObserver(
    ([entry]) => header.classList.toggle('scrolled', !entry.isIntersecting),
    { threshold: 0, rootMargin: '-1px 0px 0px 0px' }
  );
  const sentinel = document.createElement('div');
  sentinel.style.cssText = 'position:absolute;top:0;left:0;height:1px;width:100%;pointer-events:none;';
  document.body.prepend(sentinel);
  observer.observe(sentinel);
})();

// --- Accordion --------------------------------------------------------------- //
(function initAccordions() {
  document.querySelectorAll('.accordion-trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      const content = trigger.nextElementSibling;
      trigger.setAttribute('aria-expanded', String(!isOpen));
      content.classList.toggle('is-open', !isOpen);
    });
  });
})();

// --- Product Image Gallery --------------------------------------------------- //
(function initProductGallery() {
  const mainImg  = document.getElementById('product-main-image');
  const thumbs   = document.querySelectorAll('.product-media-thumb');
  if (!mainImg || !thumbs.length) return;

  const dataEl = document.querySelector('[data-variant-json]');
  let variants = null;
  if (dataEl) {
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = null; }
  }
  const form = dataEl ? dataEl.closest('form') : null;

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
       const src = thumb.querySelector('img')?.src;
      if (src) {
        mainImg.src = src.split('?')[0] + '?width=900';
        mainImg.alt = thumb.querySelector('img')?.alt || '';
      }
      thumbs.forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');

      if (!variants || !form || !src) return;
     const thumbFile = src.split('?')[0].split('/').pop();
      const matches = variants.filter((v) => v.featured_image && v.featured_image.src.split('?')[0].split('/').pop() === thumbFile);
      if (!matches.length) return;

      form.querySelectorAll('.variant-pills').forEach((group) => {
        const position = parseInt(group.dataset.optionPosition, 10);
        const key = 'option' + position;
        const values = matches.map((v) => v[key]);
        const sameForAll = values.every((val) => val === values[0]);
        if (!sameForAll) return;

        const targetValue = values[0];
        const targetPill = group.querySelector('.variant-pill[data-value="' + CSS.escape(targetValue) + '"]');
        if (!targetPill || targetPill.classList.contains('selected')) return;

        group.querySelectorAll('.variant-pill').forEach((p) => p.classList.remove('selected'));
        targetPill.classList.add('selected');

        const selector = group.closest('.variant-selector');
        const label = selector ? selector.querySelector('.variant-selector__label strong') : null;
        if (label) label.textContent = targetValue;
      });

      const selections = [];
      form.querySelectorAll('.variant-pills').forEach((g) => {
        const selectedPill = g.querySelector('.variant-pill.selected') || g.querySelector('.variant-pill');
        const position = parseInt(g.dataset.optionPosition, 10);
        if (selectedPill && position) selections[position - 1] = selectedPill.dataset.value;
      });
      const matchedVariant = variants.find((v) => {
        return [v.option1, v.option2, v.option3]
          .slice(0, selections.length)
          .every((opt, i) => opt === selections[i]);
      });
      if (!matchedVariant) return;

      const hiddenInput = form.querySelector('input[name="id"]');
      if (hiddenInput) hiddenInput.value = matchedVariant.id;

      const atcBtn = form.querySelector('.atc-btn');
      if (atcBtn) {
        atcBtn.disabled = !matchedVariant.available;
        atcBtn.textContent = matchedVariant.available ? 'Add to Cart' : 'Sold Out';
      }
    });
  });
})();

// --- Quantity Selector ------------------------------------------------------- //
(function initQtySelector() {
  document.querySelectorAll('.qty-selector').forEach((wrap) => {
    const input  = wrap.querySelector('.qty-input');
    const minus  = wrap.querySelector('.qty-btn--minus');
    const plus   = wrap.querySelector('.qty-btn--plus');
    if (!input) return;

    if (minus) {
      minus.addEventListener('click', () => {
        const v = parseInt(input.value, 10);
        if (v > 1) input.value = v - 1;
      });
    }
    if (plus) {
      plus.addEventListener('click', () => {
        const v = parseInt(input.value, 10);
        input.value = v + 1;
      });
    }
  });
})();

// --- Variant Pill Selection ------------------------------------------------ //
(function initVariantPills() {
document.querySelectorAll('.variant-pills').forEach((group) => {
const form = group.closest('form');
const dataEl = form ? form.querySelector('[data-variant-json]') : null;
let variants = null;
if (dataEl) {
try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = null; }
}

group.querySelectorAll('.variant-pill').forEach((pill) => {
pill.addEventListener('click', () => {
if (pill.classList.contains('sold-out')) return;
group.querySelectorAll('.variant-pill').forEach(p => p.classList.remove('selected'));
pill.classList.add('selected');

const selector = group.closest('.variant-selector');
const label = selector ? selector.querySelector('.variant-selector__label strong') : null;
if (label) label.textContent = pill.dataset.value;

if (!form || !variants) return;

const selections = [];
form.querySelectorAll('.variant-pills').forEach((g) => {
const selectedPill = g.querySelector('.variant-pill.selected') || g.querySelector('.variant-pill');
const position = parseInt(g.dataset.optionPosition, 10);
if (selectedPill && position) {
selections[position - 1] = selectedPill.dataset.value;
}
});

const matchedVariant = variants.find((v) => {
return [v.option1, v.option2, v.option3]
.slice(0, selections.length)
.every((opt, i) => opt === selections[i]);
});

if (!matchedVariant) return;

const hiddenInput = form.querySelector('input[name="id"]');
if (hiddenInput) hiddenInput.value = matchedVariant.id;

if (matchedVariant.featured_image) {
const mainImg = document.getElementById('product-main-image');
const thumbs = document.querySelectorAll('.product-media-thumb');
const targetPath = matchedVariant.featured_image.src.split('?')[0];
let matchedThumbImg = null;

thumbs.forEach((thumb) => {
const thumbImg = thumb.querySelector('img');
const isMatch = thumbImg && thumbImg.src.split('?')[0] === targetPath;
thumb.classList.toggle('active', isMatch);
if (isMatch) matchedThumbImg = thumbImg;
});

if (mainImg) {
mainImg.src = targetPath + '?width=900';
mainImg.alt = (matchedThumbImg && matchedThumbImg.alt) || matchedVariant.featured_image.alt || mainImg.alt;
}
}

const atcBtn = form.querySelector('.atc-btn');
if (atcBtn) {
atcBtn.disabled = !matchedVariant.available;
atcBtn.textContent = matchedVariant.available ? 'Add to Cart' : 'Sold Out';
}
});
});
});
})();

// --- Scroll Animation Observer ---------------------------------------------- //
(function initScrollAnimations() {
  const elements = document.querySelectorAll('.animate-on-scroll');
  if (!elements.length) return;
  if (!window.IntersectionObserver) {
    elements.forEach((el) => el.classList.add('in-view'));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
  );
  elements.forEach((el) => observer.observe(el));
})();

// --- Trade Application Form ------------------------------------------------- //
(function initTradeForm() {
  const form = document.getElementById('trade-application-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Submitting...';

    // Shopify contact form submission
    const data = new FormData(form);
    try {
      const res = await fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(data).toString(),
      });
      if (res.ok) {
        form.innerHTML = `
          <div style="text-align:center;padding:4rem 2rem;">
            <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#1a6b1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin:0 auto 1.6rem;display:block"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
            <h3 style="font-family:var(--font-heading-family);font-size:2.8rem;margin-bottom:1rem;">Application Received</h3>
            <p style="color:#555;font-size:1.6rem;max-width:48rem;margin:0 auto;">Thank you for your interest in becoming a Nalini Australia stockist. Our trade team will review your application and contact you within 2&ndash;3 business days.</p>
          </div>`;
      } else {
        throw new Error('Submission failed');
      }
    } catch {
      btn.disabled = false;
      btn.textContent = originalText;
      alert('There was an error submitting your application. Please try again or email trade@nalini.com.au');
    }
  });
})();

// --- Search Toggle ----------------------------------------------------------- //
(function initSearch() {
  const openBtn  = document.getElementById('search-toggle');
  const closeBtn = document.getElementById('search-close');
  const overlay  = document.getElementById('search-overlay');
  const input    = document.getElementById('search-input');
  if (!openBtn || !overlay) return;

  openBtn.addEventListener('click', () => {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    setTimeout(() => input?.focus(), 100);
  });

  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
  }

  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeSearch();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });
})();
document.addEventListener('DOMContentLoaded', function () {
  var zoomBox = document.querySelector('.product-media-main');
  if (!zoomBox) return;

  zoomBox.addEventListener('mousemove', function (e) {
    var img = zoomBox.querySelector('img');
    if (!img) return;
    var rect = zoomBox.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = x + '% ' + y + '%';
  });

  zoomBox.addEventListener('mouseenter', function () {
    zoomBox.classList.add('is-zoomed');
  });

  zoomBox.addEventListener('mouseleave', function () {
    zoomBox.classList.remove('is-zoomed');
  });
});
document.addEventListener('DOMContentLoaded', function () {
  var discountForm = document.getElementById('cart-discount-form');
  var discountInput = document.getElementById('discount-code-input');
  var discountError = document.getElementById('discount-error');

  if (discountForm && discountInput) {
    discountForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = discountInput.value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
  }

  if (discountError) {
    fetch('/cart.json')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        var invalid = null;
for (var i = codes.length - 1; i >= 0; i--) {
  if (!codes[i].applicable) { invalid = codes[i]; break; }
}
        if (invalid) {
          discountError.textContent = '"' + invalid.code + '" is not a valid discount code.';
          discountError.style.display = 'block';
          discountInput.value = invalid.code;
        }
      })
      .catch(function () {});
  }
});
